import React, {useEffect} from 'react';
import PropTypes from 'prop-types';

import {currentResource} from '../../../util/utils';

import columns from './columns';

import CustomTable from '../../CoreWrappers/CustomTable';

const NotRelatedComponentAccountsTable = ({items, action, labelPropName}) => {
	if (!items) return false;
	const labels = currentResource.notRelatedAccountsTableLabels;
	const columnLabels = {...labels.columns, ...labels.columns[labelPropName]};

	const props = {
		id: 'notRelatedComponentAccountsTable',
		data: items,
		columns: columns(columnLabels, action),
		labels: {
			emptyMessage: labels.noDataFound,
			show: labels.show
		}
	};

	return <CustomTable {...props} />;
};

NotRelatedComponentAccountsTable.propTypes = {
	items: PropTypes.arrayOf(
		PropTypes.shape({
			componentAccount: PropTypes.string.isRequired,
			pspIndexes: PropTypes.any.isRequired,
			notApplicable: PropTypes.string.isRequired
		})
	)
};

export default NotRelatedComponentAccountsTable;
